export const PENDING_CHECKOUT_KEY = 'nn_pending_checkout';
export const CHECKOUT_MESSAGE_TYPE = 'nn_checkout_complete';
